import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import axios from "axios";
import { store } from "./store";
import PersistProvider from "./store/providers/persist-provider";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {
  setAxiosClientInterceptor,
} from "./helpers/apiClient";

import "animate.css";
import "swiper/swiper-bundle.min.css";
import "./assets/scss/style.scss";

setAxiosClientInterceptor();
// const container = document.getElementById("root");
const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
      <PersistProvider>
        <App />
      </PersistProvider>
    </Provider>,
  );
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
